import { LoadingSkeleton } from '@joor/design-system'
import styled from 'styled-components/macro'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 16px;
`

export const LoadingNotesWidget = () => (
  <Container>
    <LoadingSkeleton width="57%" />
    <LoadingSkeleton count={5} />
  </Container>
)
